import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { validateTokenApi } from '../../../Api/User/validateTokenApi';
import { safePathName } from '../../../utils/helpers';

export const getSafeRedirect = (): string => {
  const stored = sessionStorage.getItem('postLoginRedirect') || '/';
  sessionStorage.removeItem('postLoginRedirect');
  return safePathName(stored);
};

export const AuthenticatePage = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const validateToken = async (token: string) => {
      const { data, error } = await validateTokenApi(token);
      if (data) {
        localStorage.setItem('token', token);
        const redirectTo = getSafeRedirect();
        navigate(redirectTo);
        navigate(0);
      }
      if (error) navigate('/login');
    };

    const token = params.get('token') || '';

    if (token && token === localStorage.getItem('token')) {
      const redirectTo = getSafeRedirect();
      navigate(redirectTo);
    } else if (token) {
      validateToken(token);
    } else {
      navigate('/login');
    }
  }, [navigate, params]);

  return (
    <div className="text-center">
      <img
        src="/UPSTACK_logo_hrz-1.5_color.svg"
        className="m-auto h-[80px] mt-24"
        alt="UPSTACK Logo"
      />
    </div>
  );
};
